import React from "react";

import { Row, SpicyButton } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

type TagSuggestionMenuOptionsProps = {
  onDiscardPress: () => void;
  onSendPress: () => void;
};

function TagSuggestionMenuOptions({ onDiscardPress, onSendPress }: TagSuggestionMenuOptionsProps) {
  return (
    <Row className="gap-3">
      <SpicyButton onPress={onDiscardPress} variant="bordered" radius="full" size="sm">
        <Trans i18nKey="chatbot:tags.suggestions.discard" />
      </SpicyButton>
      <SpicyButton onPress={onSendPress} color="primary_strong" radius="full" size="sm">
        <Trans i18nKey="chatbot:tags.suggestions.send" />
      </SpicyButton>
    </Row>
  );
}

export default React.memo(TagSuggestionMenuOptions);
